import { fnBrowserDetect } from '../../../../../../../../../utility/browsers';
import { SAFARI } from '../../../../../../../../../utility/enums/browsers';
import scrollToSlateNode from '../utils/scrollToSlateNode';

export default (params) => {
  const { editor, currentRole, mostUsedToolSetRef, props } = params;
  const {
    value: { document },
  } = editor;
  /**
   * Fetch organization data
   */
  const organization = document.getParent(currentRole.key);
  const { nodes: organizationNodes, data: organizationData } = organization;
  const organizationDataJSON = organizationData.toJSON();
  let { selectAll } = organizationDataJSON;
  const { size: organizationNodesSize } = organizationNodes;

  /**
   * preventing the delete action when there is only one role
   *
   * Every organization has 3 nodes by default
   * organization details + n* ( role details + paragraph )
   */

  const noOfRoles = organizationNodesSize - 1;
  if (noOfRoles === 1) return;

  editor.removeNodeByKey(currentRole.key);

  const roleIndexInOrganization = organization.nodes.indexOf(currentRole);
  const roleIndexInRoles = Math.ceil(roleIndexInOrganization);

  let jobTitle = organizationNodes.toArray()[roleIndexInOrganization + 1];

  /**
   * When current role is the last role and
   * no.of roles > 1
   */
  if (roleIndexInRoles === noOfRoles) {
    const previousRole =
      organizationNodes.toArray()[roleIndexInOrganization - 1];
    jobTitle = previousRole;
  }

  const { data: currentRoleData } = currentRole;
  const roleExport = currentRoleData.get('toExport');
  if (roleExport) {
    selectAll -= 1;
  }

  /**
   * Set organization data
   */
  editor.setNodeByKey(organization.key, {
    data: {
      ...organizationDataJSON,
      selectAll,
    },
  });

  /**
   * Set document data
   */
  const { data: documentData, key: currDocumenKey } = document;
  const documentDataJSON = documentData.toJSON();
  const { rolesCount: prevRolesCount, selectAll: prevDocSelectAll } =
    documentDataJSON;
  if (roleExport) {
    editor.setNodeByKey(currDocumenKey, {
      data: {
        ...documentDataJSON,
        rolesCount: prevRolesCount - 1,
      },
    });
    // .moveToEndOfNode(jobTitle);
    // if (window.env !== 'test') editor.focus();
  } else if (selectAll && selectAll === noOfRoles - 1) {
    editor.setNodeByKey(currDocumenKey, {
      data: {
        ...documentDataJSON,
        selectAll: prevDocSelectAll + 1,
      },
    });
    // .moveToEndOfNode(jobTitle);
    // if (window.env !== 'test') editor.focus();
  }

  const { type: nodeType } = currentRole;

  if (nodeType === 'skill_title') {
    editor.moveToEndOfNode(jobTitle);
    if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
    scrollToSlateNode(jobTitle, mostUsedToolSetRef, props);
  } else {
    editor.moveToStartOfNode(jobTitle);
    if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
    const {
      value: { focusBlock },
    } = editor;
    const { key: focusBlockKey } = focusBlock;
    if (focusBlock && focusBlockKey) {
      editor.moveToEndOfNode(focusBlock);
    }
    scrollToSlateNode(jobTitle);
  }
};
